import script from "./BumperDraggableGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./BumperDraggableGroup.vue?vue&type=script&lang=ts&setup=true"

import "./BumperDraggableGroup.vue?vue&type=style&index=0&id=2062bfb2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2062bfb2"]])

export default __exports__